class TriageAnswer {
  constructor(title, hint, rank, triageQuestionId, nextTriageQuestionId) {
    this.title = title;
    this.hint = hint;
    this.rank = rank;
    this.triageQuestionId = triageQuestionId;
    this.nextTriageQuestionId = nextTriageQuestionId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      isOpenGoTo: false,
      selectedGoTo: null,
      searchGoToText: '',
      searchGoToQuestionText: '',
      showGoToQuetion: false,
      isOpenGoToQuestion: false,
      selectedGoToQuestion: null,
      questionId: null,
      questionTitle: '',
      isAdd: false,
      disabelConfirm: false,
      answerId: null,
    };
  },
  methods: {
    showConfirmDialogFunction: function () {
      if (this.isAdd == true) {
        this.addTriageAnswerFunction();
      } else if (this.isAdd == false) {
        this.$refs.confirm.title = 'ویرایش پاسخ';
        this.$refs.confirm.text = 'از ویرایش پاسخ اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.isAdd == true) {
        this.disabelConfirm = true;
        this.addTriageAnswerFunction();
      } else if (this.isAdd == false) {
        this.disabelConfirm = true;
        this.editTriageAnswerFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.isAdd == true) {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.isAdd == false) {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    goToOpenClose: function (type) {
      if (type == 1) {
        this.isOpenGoTo = true;
      } else if (type == 2) {
        this.isOpenGoTo = false;
      }
    },
    goToQuestionOpenClose: function (type) {
      if (type == 1) {
        this.isOpenGoToQuestion = true;
      } else if (type == 2) {
        this.isOpenGoToQuestion = false;
      }
    },
    selectGoToItem: function (data) {
      let info = [];
      for (let i = 0; i < this.allChiefComplaintsForOther.length; i++) {
        info.push(this.allChiefComplaintsForOther[i]);
        this.allChiefComplaintsForOther.splice(i, 1);
        i--;
      }
      if (data) {
        for (let i = 0; i < info.length; i++) {
          if (data.id == info[i].id) {
            info[i].class = '';
            info[i].class = 'mr-3 mt-2 selected-go-to-item';
          } else {
            info[i].class = 'mr-3 mt-2';
          }
        }
        this.selectedGoTo = null;
        this.selectedGoTo = data;
        this.showSelectGoToQuestion();
      } else {
        this.selectedGoTo = null;
        this.selectedGoToQuestion = null;
        for (let i = 0; i < info.length; i++) {
          info[i].class = 'mr-3 mt-2';
        }
        let info2 = this.allTriageQuestions;
        for (let i = 0; i < info2.length; i++) {
          info2[i].class = 'mr-3 mt-2';
        }
        this.allTriageQuestions = [];
        this.allTriageQuestions = info2;
        this.showGoToQuetion = false;
        this.isOpenGoToQuestion = false;
      }
      for (let i = 0; i < info.length; i++) {
        this.allChiefComplaintsForOther.push(info[i]);
        info.splice(i, 1);
        i--;
      }
    },
    selectGoToQuestionItem: function (data) {
      let info = this.allTriageQuestions;
      if (data) {
        for (let i = 0; i < info.length; i++) {
          if (data.id == info[i].id) {
            info[i].class = null;
            info[i].class = 'mr-3 mt-2 selected-go-to-item';
          } else {
            info[i].class = 'mr-3 mt-2';
          }
        }
        this.selectedGoToQuestion = data;
      } else {
        this.selectedGoToQuestion = null;
        for (let i = 0; i < info.length; i++) {
          info[i].class = 'mr-3 mt-2';
        }
      }
      this.allTriageQuestions = [];
      this.allTriageQuestions = info;
    },
    showSelectGoToQuestion: function () {
      this.getAllTriageQuestionsWithCheifComplaintIdFunction(this.selectedGoTo.id);
      this.showGoToQuetion = true;
      this.isOpenGoToQuestion = true;
    },
    cancelAddTriageAnswer: function () {
      this.triageAnswer = new TriageAnswer('', '', null, null, null);
      let id = this.questionId;
      this.$router.push({ name: 'triageAnswer', params: { id: id } });
    },
  },
};
